import React from 'react';
import BottomNav from '../components/BottomNav';

const Travel = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Luxury Travel</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Bespoke Travel Experiences</p>
        
        <div className="card">
          <p>
            Experience the world in unparalleled luxury. From private jets to exclusive resorts, 
            we curate extraordinary travel experiences tailored to your desires.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Private Aviation</h3>
              <p>Access to private jets and helicopter charters</p>
            </div>
            <div className="feature-item">
              <h3>Luxury Accommodations</h3>
              <p>Premier suites at the world's finest hotels and resorts</p>
            </div>
            <div className="feature-item">
              <h3>Bespoke Itineraries</h3>
              <p>Customized travel plans crafted by expert concierges</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default Travel;
